<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
	<h4 class="modal-title">{{TYPE_GATEWAY type}} - {{TR "Firmware-Einstellungen"}}</h4>
</div>
<div class="modal-body">
	{{#if error}}
	<div class="alert alert-danger">{{error}}</div>
	{{/if}}

	{{#each intervals}}
	<div class="row">
		<div class="col-sm-12">
			<div class="input-group m-t-10">
				<span class="input-group-addon font-weight-bold">{{TR "Intervall für Update-Klasse "}}{{MATH  @index '+' 1}}</span>
				<input type="number" id="push_interval_{{@index}}-input" name="push_{{@index}}" class="form-control" min="0" max="65535" value="{{this}}">
				<span class="input-group-addon">{{TR "Min."}}</span>
			</div>
		</div>
	</div>
	{{/each}}

	{{#if hasMultipleTabs}}
	<ul class="nav nav-tabs tabs">
		{{#each tabs}}
		<li class="{{#if active}}active{{/if}}">
			<a href="#{{id}}" data-toggle="tab" aria-expanded="false">{{name}}</a>
		</li>
		{{/each}}
	</ul>
	<div class="tab-content no-padding no-shadow">
	{{/if}}

	{{#each tabs}}
	{{#if ../hasMultipleTabs}}<div class="tab-pane{{#if active}} active{{/if}}" id="{{id}}">{{/if}}

	<div class ="grid-container grid-column-auto-4 m-t-20">
		<label class="control-label col-sm-4" for="Z{{@index}}"></label>
		<label class="control-label col-sm-2" for="Address{{@index}}">{{TR "Adresse"}}</label>
		<label class="control-label col-sm-3" for="WMZ1_type_sel">{{TR "Typ"}}</label>
		<label class="control-label col-sm-3" for="WMZ1_reading_mode_sel">{{TR "Auslesemodus"}}</label>
		{{#each wmzs}}
		<div>
			<input id="checkbox{{meterNr}}" name="active{{meterNr}}" type="checkbox" {{#COMPARE adr '!=' '255' }}checked{{/COMPARE}}>
			<span class="control-label" id="Z{{meterNr}}">{{TR "Zähler "}}{{MATH meterNr '+' 1}}</span>
		</div>
		<input type="number" id="AddressWMZ{{meterNr}}-input" class="form-control input-sm" name="adr_{{meterNr}}" min="0" max="255" value="{{adr}}"  {{#COMPARE adr '==' '255' }} disabled {{/COMPARE}}>
		{{#SELECT type}}
		<select  class="form-control input-sm" id="WMZ{{meterNr}}_type_sel" name ="type_{{meterNr}}" {{#COMPARE adr '==' '255' }}disabled{{/COMPARE}}>
			{{#each ../../values}}
			<option  value="{{@key}}">{{this}}</option>
			{{/each}}
		</select>
		{{/SELECT}}
		{{#SELECT mode}}
		<select  class="form-control input-sm" id="WMZ{{meterNr}}_reading_mode_sel"  name="mode_{{meterNr}}" {{#COMPARE adr '==' '255' }}disabled{{/COMPARE}}>
			{{#each ../../mode_values}}
			<option  value="{{@key}}">{{this}}</option>
			{{/each}}
		{{/SELECT}}
		{{/each}}
	</div>

	{{#if ../hasMultipleTabs}}</div>{{/if}}
	{{/each}}

	{{#if hasMultipleTabs}}
	</div>
	{{/if}}

	{{#if canConfigureMBus}}
		<div class="row m-t-10">
			<div class="col-sm-12">
				<div class="input-group m-t-10">
					<span class="input-group-addon font-weight-bold">{{TR "Ausleseintervall"}}</span>
					<input type="number" id="read_interval-input" name="interval" class="form-control" min="1" max="65535" value="{{interval}}">
					<span class="input-group-addon">{{TR "Sek."}}</span>
				</div>
				<div id="js-interval-hint" class="alert alert-warning m-t-10" {{#unless showIntervalHint}}style="display: none"{{/unless}}>
					<strong>{{TR "Hinweis"}}</strong>:
					{{TR "Ein Ausleseintervall kleiner als 1 Minute wird eventuell von angeschlossenen Zählern nicht unterstützt."}}
				</div>
			</div>
		</div>
	{{/if}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-success">{{TR "Schreiben"}}</button>
</div>
